<template>
  <div class="box">
    <div class="teachersbox" v-if="teacherInfo && teacherInfo.length > 0">
      <div class="tops">

        <!-- <img src="../../assets/images/gifts/photo.png" alt=""> -->
        <div class="tops-cont">
          <img :src="teacherInfo[1].avatar" alt="">
          <span class="name">{{ teacherInfo[1].whoami }}</span>

        </div>
        <div class="right">

          <div class="list">
            <div>
              <span class="names">{{ teacherInfo[1].tradecnt || '' }} </span>
              <span>交易笔数 </span>

            </div>
            <div>
              <span class="names">{{ teacherInfo[1].winrate + '%' || '' }} </span>
              <span>交易胜率</span>

            </div>
            <div>
              <span class="names">{{ teacherInfo[1].gainrate + '%' || '' }} </span>
              <span>交易回报率 </span>

            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="tit">简介</div>
        <div>
          {{ teacherInfo[1].intro }}
        </div>
      </div>
      <div class="gifts">
        <div class="infos">
          <img :src="teacherInfo[1].avatar" alt="">

          <div class="tit">{{ teacherInfo[1].whoami }}老师 收到的礼物</div>

        </div>
        <div class="cont">
          <div class="col">
            <div class="commen">普通礼物</div>

            <div class="lefts">
              <div class="empty" v-if="ordinaryGiftList.length === 0">
                <img src="../../assets/images/empty-gift.png" alt="">
                <span>暂无</span>
              </div>
              <div class="item" v-for="(item, index) in ordinaryGiftList" :key="index">
                <div class="lists">
                  <span>{{ item.nick }}</span>
                  <span>送出 <span class="weight">{{ item.name }}</span></span>
                  <span>X1</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="commen">真情礼物</div>

            <div class="rights">
              <div class="empty" v-if="sincerelyGiftList.length === 0">
                <img src="../../assets/images/empty-gift.png" alt="">
                <span>暂无</span>
              </div>
              <div class="item" v-for="(item, index) in sincerelyGiftList" :key="index">
                <div class="lists">
                  <span>{{ item.nick }}</span>
                  <span>送出 <span class="weight">{{ item.name }}</span></span>
                  <span>X1</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="teachersbox" v-else>
      <div class="tops">
        <div class="tops-cont">
          <img :src="defaultTeacherInfo.avatar" alt="">

          <span class="name">{{ defaultTeacherInfo.whoami }}</span>

        </div>
        <div class="right">

          <div class="list">
            <div>
              <span class="names">交易笔数</span>
              <span>{{ defaultTeacherInfo.tradecnt || '' }} </span>
            </div>
            <div>
              <span class="names">交易胜率</span>
              <span>{{ defaultTeacherInfo.winrate + '%' || '' }} </span>
            </div>
            <div>
              <span class="names">交易回报率</span>
              <span>{{ defaultTeacherInfo.gainrate + '%' || '' }} </span>
            </div>
          </div>

        </div>
      </div>
      <div class="content">
        <div class="tit">讲师简介</div>
        <div>
          商管专业，具备多年实战经验，专职交易员7年以上；擅长伦敦金、美股与虚拟货币；热衷于区块链技术应用与虚拟币领域分析；技术分析大牛，对K线、指标、斐波那契、波浪理论等有独特的推算与时间循环理论；善用宏观经济掌握进退场的周期。
        </div>
      </div>
      <div class="gifts">
        <div class="infos">
          <img :src="defaultTeacherInfo.avatar" alt="">


          <div class="tit">{{ defaultTeacherInfo.whoami }}老师 收到的礼物</div>

        </div>
        <div class="cont">
          <div class="col">
            <div class="commen">普通礼物</div>

            <div class="lefts">
              <div class="empty">
                <img src="../../assets/images/empty-gift.png" alt="">
                <span>暂无</span>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="commen">真情礼物</div>

            <div class="rights">
              <div class="empty">
                <img src="../../assets/images/empty-gift.png" alt="">
                <span>暂无</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import { GetGiveGiftList } from "../../api/home.js";
import { mapState } from "vuex";

export default {
  name: 'wapTeacher',
  data() {
    return {
      control: false,
      teacher: {
        time: '16:09',
        visible: false,
        visibleWidth: '800px',
      },
      List: [
        { name: '36', value: '交易笔数' },
        { name: '72%', value: '交易胜率' },
        { name: '15%', value: '交易回报率' }
      ],
      ordinaryGiftList: [],//普通礼物
      sincerelyGiftList: [],//真情礼物
      tableTop: 0,
      tableTop_2: 0,
      tableListSize: 0,
      tableTimer: null,
      tableTimer_2: null,
      componentTimer: null,
      visibleSize: 6, //容器内可视最大完整行数
      lineHeight: 16, //每行的实际高度（包含margin-top/bottom,border等）
      componentTimerInterval: 3600000, //刷新数据的时间间隔
      tableTimerInterval: 100, //向上滚动 1px 所需要的时间，越小越快，推荐值 100
      animate: 0,

    }
  },
  beforeDestroy() {
    // 离开页面销毁
    clearInterval(this.tableTimer);
    clearInterval(this.tableTimer_2);
    this.tableTop = 0;
    this.tableTop_2 = 0;
  },
  computed: {
    // craig--newAdd
    teacherInfo() {
      console.log('讲师信息------', this.$store.state.home.teacherInfo)
      return this.$store.state.home.teacherInfo
    },
    bnotes() {
      return this.$store.state.home.bnotes
    },
    ...mapState("common", {
      live800UrlUc: 'live800UrlUc',
    }),
    defaultTeacherInfo(){
      return this.$store.state.home.defaultTeacherInfo
    },
  },
  created() {
    console.log('讲师数据---------', this.$store.state.home.teacherInfo)
    this.geiRoomGiftList()
  },
  mounted() {
    this.scrollList()

  },
  deactivated() {
    clearInterval(this.animate)
  },
  beforeDestroy() {
    clearInterval(this.animate)
  },
  methods: {
    // 礼物列表滚动
    scrollList() {
      const swiperList = document.getElementsByClassName("lefts");
      const swiperList1 = document.getElementsByClassName("rights");
      console.log('--------------', swiperList)
      this.animate = setInterval(() => {
        for (let i = 0; i < swiperList.length; i++) {
          let maxtop = swiperList[i].scrollHeight - swiperList[i].offsetHeight;
          if (maxtop === 0) {
            continue;
          }
          swiperList[i].scrollTop += 1
          if (swiperList[i].scrollTop >= (maxtop - 1)) {
            swiperList[i].scrollTop = 0
          }
        }
      }, 80);
      this.animate = setInterval(() => {
        for (let i = 0; i < swiperList1.length; i++) {
          let maxtop = swiperList1[i].scrollHeight - swiperList1[i].offsetHeight;
          if (maxtop === 0) {
            continue;
          }
          swiperList1[i].scrollTop += 1
          if (swiperList1[i].scrollTop >= (maxtop - 1)) {
            swiperList1[i].scrollTop = 0
          }
        }
      }, 80);
    },

    // 获取房间礼物列表事件
    geiRoomGiftList() {
      clearInterval(this.tableTimer);
      clearInterval(this.tableTimer_2);
      this.tableTop = 0;
      this.tableTop_2 = 0;
      let params = {
        tname: this.teacherInfo[1].whoami,
        size: 1000000,
        platid: 1
      }
      GetGiveGiftList(params).then(res => {
        if (res.Status === 0) {
          console.log('liwu-------',res)
          this.ordinaryGiftList = []
          this.sincerelyGiftList = []
          res.content.forEach(item => {
            if (item.gifttype === 1) {
              // 普通礼物
              this.ordinaryGiftList.push(item)
            } else if (item.gifttype === 2) {
              // 真心礼物
              this.sincerelyGiftList.push(item)
            }
          })
          console.log('普通礼物------', this.ordinaryGiftList)
          console.log('真情礼物------', this.sincerelyGiftList)
          this.tableActionFun('ordinaryGiftList', 'tableTimer', 'tableTop'),
          this.tableActionFun('sincerelyGiftList', 'tableTimer_2', 'tableTop_2')
        }
      })
    },
    // 控制讲师简介的显示
    controlClick() {
      this.control = !this.control;
    },
    // 
    showDialog() {
      this.teacher.visible = true;
    },
    // 处理只显示十个字符，其他的用...代替
    getNewName(name) {
      var len = 0;
      var reallen = 0;
      for (var j = 0; j < name.length; j++) {
        if (name.charCodeAt(j) > 127 || name.charCodeAt(j) == 94) {
          len += 1;
        } else {
          len++;
        }
        if (len < 11) {
          reallen++;
        }
      }
      if (len > 10) {
        name = name.substr(0, reallen) + '···';
      }
      return name;
    },
    // 时间戳转时间格式
    timestampToTime(timestamp) {
      let date = new Date(parseInt(timestamp));
      let Year = date.getFullYear();
      let Moth = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      let Day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
      let Hour = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
      let Minute = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      let Sechond = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return Hour + ':' + Minute;
    },
    //调用数据接口，获取列表数据，根据自己情况填接口url
    bsGetProductProcess() {
      clearInterval(this.tableTimer);
      clearInterval(this.tableTimer_2);
      this.tableTop = 0;
      this.tableTop_2 = 0;
      this.tableActionFun();
    },
    tableActionFun(list, Timer, topType) {
      // this.tableListSize = this.tableList.length;
      if (this[list].length > this.visibleSize) {
        this[list] = this[list].concat(this[list]);
        this.tableTimerFun(list, Timer, topType);
      } else {
        // this.fillTableList(list, Timer, topType);
      }
    },
    tableTimerFun(list, Timer, topType) {
      var count = 0;
      this[Timer] = setInterval(() => {
        if (count < (this[list].length / 2) * this.lineHeight) {
          this[topType] -= 1;
          count++;
        } else {
          count = 0;
          this[topType] = 0;
        }
      }, this.tableTimerInterval);
    },
    //当数据过少时，不触发自动轮播事件，并填充没有数据的行，参数根据实际情况修改即可
    fillTableList(list, Timer, topType) {
      var addLength = this.visibleSize - this[list].length;
      for (var i = 0; i < addLength; i++) {
        this[list].push({
          name: '--',
          giftName: '--',
          number: '0'
        });
      }
    },
  }
}
</script>

<style lang="less" scoped>
.box {
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: normal;
  box-sizing: border-box;
  padding: 10px 10px 100px;
  background: url('../../assets/images/gifts/bgs.png');
  background-size: 100% 100%;

  .notice {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    background: #EEF5FF;

    img {
      width: 16px;
      height: 16px;
    }

    span {
      color: #2C3EB9;
      font-size: 12px;
      line-height: 17px;
      font-weight: 500;
    }

    .news {
      color: #FE2C55;

    }
  }

  .teacherBox {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 15px;

    .teacherHeaderImg {
      width: 55px;
      height: 55px;
      margin-right: 8px;
      border-radius: 10px;
    }

    div {
      .levelImg {
        width: 35px;
        margin-bottom: 10px;
      }

      p {
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          font-size: 16px;
          font-weight: 600;
          margin-right: 8px;
        }

        img {
          cursor: pointer;
        }
      }
    }

    .currentlyOnline {
      position: absolute;
      bottom: 0px;
      right: 0px;
      font-size: 14px;

      span {
        color: #ee2547;
      }
    }

    .goDown {
      width: 15px;
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .newAddINT {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .introduce {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .introduceBox {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        width: 100%;
        height: auto;
        line-height: 18px;
        font-size: 13px;
        color: #000;
        margin-bottom: 5px;
      }
    }

    .recordBox {
      width: 100%;
      display: flex;
      border: 1px solid #ebce7b;
      border-radius: 8px;

      .recordBoxLeftImg {
        height: 60px;
      }

      ul {
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding: 0 20px;

        li {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          span {
            font-size: 18px;
            font-weight: 600;
          }

          p {
            display: flex;
            align-items: center;
            font-size: 12px;

            img {
              margin-right: 5px;
            }
          }
        }

        label {
          width: 1px;
          height: 30px;
          background-color: #fae6d2;
          margin: 0 15px;
        }
      }
    }
  }

  .goUp {
    width: 15px;
    margin-top: 10px;
  }

  .simple {
    width: 890px;
    height: 65px;
    background: url('../../assets/images/teacherJs/redBackground.png') no-repeat;
    background-size: 100% 100%;
    color: #fff;
    font-size: 26px;
    font-weight: 550;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .teachersbox {
    width: 100%;

    .tops {
      display: flex;

      flex-direction: column;
      justify-content: space-between;
      padding: 10px 30px;
      font-size: 12px;
      line-height: 17px;
      color: #475361;
      white-space: nowrap;
      background: url('../../assets/images/gifts/tcbg.png') no-repeat;
        background-size: 100% 100%;
        margin-top: 40px;
      .cart {
        width: 95px;
        height: 26px;
        border-radius: 8px;
   
        font-size: 13px;
        line-height: 18px;
        color: #2C3EB9;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 8px 0 24px;

      }
      &-cont{
        display: flex;
      
        img{
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 10px;
        }
        margin-bottom: 60px;
        padding-bottom: 10px;
      }
      .name {
        font-size: 18px;
        line-height: 25px;
        font-weight: 600;
        color: #c6b58f;
      }

      

      .right {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .list {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        div {
          display: flex;
          flex-direction: column;
          color:#888781;
          align-items: center;

        }
      }

      .names {
  
        line-height: 20px;
        margin-bottom: 4px;

    

      }
    }

    .tit {
      color: #21264C;
      text-align: left;
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
      //  margin-bottom: 8px;
    }

    .content {
      color: #475361;
      font-size: 13px;
      line-height: 18px;
      margin-top: 20px;
      margin-bottom: 20px;
      height: auto;
      
    }

    .gifts {
      margin-top: 20px;

      .infos {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 4px;
        }
      }

      .cont {
        display: flex;
        align-items: flex-start;
      }

      // 普通礼物 / 真情礼物 两列，各自等宽自适应
      .col {
        flex: 1;
        min-width: 0;
        border-radius: 12px;
        background: #F7F7F7;
        overflow: hidden;

        & + .col {
          margin-left: 12px;
        }
      }

      .commen {
        color: #333;
        font-weight: 600;
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        padding: 8px 6px;
        box-sizing: border-box;
      }

      .lefts,
      .rights {
        height: 100px;
        overflow: hidden;
        overflow-y: auto;
        padding: 8px 10px;
        box-sizing: border-box;

        .ava {
          width: 20px;
          height: 20px;
          margin-right: 3px;
        }

        .lists {

          display: flex;
          align-items: center;
          font-size: 11px;
          color: #000;
          white-space: nowrap;

          .weight {
            color: #F75555;

          }
        }

        .item {
          margin: 6px 0;
        }

        .empty {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            height: 52px;
          }

          span {
            font-size: 11px;
            line-height: 16px;
            color: #A0A5AD;
            margin-top: 8px;
          }
        }
      }
    }
  }

  /deep/.el-dialog__body {
    padding: 25px 15px 20px !important;
  }

  /deep/.el-dialog__headerbtn {
    top: 10px;
    right: 10px;
  }

  .ssDialog {
    font-size: 16px;
    line-height: 30px;
  }
}
</style>